import { Component, OnInit } from '@angular/core';
import {
    CommonComponent,
    CommonElementsConfig,
} from '../common/common.component';

@Component({
    selector: 'app-dialog-ledger-withdrawal',
    templateUrl: '../common/common.component.html',
    styleUrls: ['../common/common.component.css'],
})
export class WithdrawalComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig(['amount', 'comment']);

    public override submitLabel = 'Withdraw';
    public override headingLabel = 'Withdraw from';

    public override submit() {
        let payload = {
            amount: Number(this.formGroup.get('amount')!.value),
            comment: this.formGroup.get('comment')!.value,
            sender_email: this.tgtOpenIdProfile!.email,
        };

        this.sendPayload('ledger/withdrawal', payload);
    }
}
